export const LOCALE_SCROLL_RESTORE_KEY = 'joinai:locale-scroll-restore';

export interface LocaleScrollRestoreState {
    pathname: string;
    y: number;
    createdAt: number;
}

export function getLocalizedPathname(pathname: string, locale: string) {
    const normalizedPathname = pathname.startsWith('/')
        ? pathname
        : `/${pathname}`;
    const match = normalizedPathname.match(/^\/(en|zh)(\/.*)?$/);

    if (match) {
        return `/${locale}${match[2] ?? ''}`;
    }

    if (normalizedPathname === '/') {
        return `/${locale}`;
    }

    return `/${locale}${normalizedPathname}`;
}
